import { RedoOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';
import { ExaminationStatusLabel } from './ExaminationStatusLabel';

export const ErrorInfo = styled('p')(
  ({ theme }) => css`
    margin-top: 0;
    margin-bottom: 2rem;
    font-size: 0.8rem;
    color: ${theme.palette.secondary[500]};
  `,
);

export const LoadingSpinner = styled(RedoOutlined)`
  fontSize: 28px
  color: #72799C;
   margin: 0 auto;
  `;

export const ConrainerSpinner = styled('div')`
  margin: 0 auto;
  display: flex;
`;

export const DataErrorInfo = () => {
  return (
    <>
      <ErrorInfo>
        There has been an error during the examination. It can not be fetched.
      </ErrorInfo>
    </>
  );
};

export const CenteredMessage = styled('div')`
  display: flex;
  justify-content: center;
  padding: 1rem;
  text-align: center;
`;

export const CenteredDataErrorInfo = () => (
  <CenteredMessage>
    <DataErrorInfo />
  </CenteredMessage>
);

export const CenteredCanceledInfo = () => (
  <CenteredMessage>
    <ExaminationStatusLabel status="CANCELED" />
  </CenteredMessage>
);

export const DataLoadingSpinner = () => {
  return (
    <ConrainerSpinner>
      <LoadingSpinner spin style={{ fontSize: '28px', color: '#72799C' }} />
    </ConrainerSpinner>
  );
};
